module.exports = __webpack_public_path__ + "img/lifull_homes.b65a3064.svg";